module.exports = __webpack_public_path__ + "static/img/Header-LOGO.7d15db4a.png";